/**
 * T-0318: the address the iPhone app boots its one warm spare web view on. It draws nothing, so the
 * spare holds the app booted and no screen of its own — never an error or not-found state — and
 * `ShellRuntime` still says `screen` and `ready` for it, as for any route. The next tab to load takes
 * the spare and routes it to its own address with the shell's `navigate`, without a document load.
 */
export function ShellSpareScreen() {
  return null;
}
